import React from 'react';
import { hooks } from 'botframework-webchat-component';
const { useSendMessage } = hooks;

const WelcomeCard = () => {
    // Move the hook inside the component
    const sendMessage = useSendMessage();
  const tiles = [
    {
      title: 'Easy Pay',
      subtitle: 'I want to pay my bill...',
      bgColor: '#007560',
      icon: 'fa-credit-card',
      action: 'Easy Pay',
    },
    {
      title: 'Know more',
      subtitle: 'What is D33 industry friendly power policy?',
      bgColor: '#0B7BC1',
      icon: 'fa-question-circle',
      action: 'Know more',
    },
    {
      title: 'Agent Support',
      subtitle: 'I need support from a human...',
      bgColor: '#E26D5A',
      icon: 'fa-headset',
      action: 'Agent Support',
    },
    {
      title: 'Trending articles',
      subtitle: "What's new in DEWA?",
      bgColor: '#6247AA',
      icon: 'fa-newspaper',
      action: 'Trending articles',
    },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <div
        style={{
          marginBottom: '20px',
          fontSize: '16px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img src='/rammas_icon.png' alt='Rammas' style={{ width: '100px' }} />
        <div>
          Hi, I am <b>Rammas</b> powered by ChatGPT, the virtual assistant from
          DEWA,<br /> available around the clock 24/7. How can I help you
          today?
        </div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {tiles.map((tile) => (
          <div
            key={tile.title}
            onClick={() => sendMessage(tile.subtitle)}
            style={{
              backgroundColor: '#fff',
              color: '#222222',
              boxShadow: '0px 3px 8px -1px #3232470D',
              padding: '15px',
              borderRadius: '8px',
              cursor: 'pointer',
              flex: '0 0 calc(50% - 10px)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <span style={{ marginRight: '10px' }}>
                <span className='fa-stack'>
                  <i
                    className='fas fa-circle fa-stack-2x'
                    style={{ color: tile.bgColor }}
                  ></i>
                  <i
                    className={`fas ${tile.icon} fa-stack-1x`}
                    style={{ color: '#fff' }}
                  ></i>
                </span>
              </span>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
              >
                <h4
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    fontSize: '18px',
                  }}
                >
                  {tile.title}
                </h4>
                <p style={{ margin: 0, fontSize: '14px' }}>{tile.subtitle}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WelcomeCard;
